<template>
  <eventi-list-component :utente="utente" :key="keyListaEventi" :titoloEvento="titoloEvento" :pathEventResource="pathEventResource" :linkEvent="linkEvent" tipoEvento="ANAMNESI"></eventi-list-component>
</template>

<script>
import EventiListComponent from "../../../base/components/EventiListComponent.vue";
import UtilityMixins from "../../../../../utility/UtilityMixin";
export default {
  mixins: [UtilityMixins],
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  components: {
    EventiListComponent,
  },

  watch: {
    utente: function () {
      this.keyListaEventi++;
    },
  },
  mounted() {},
  data() {
    return {
      titoloEvento: this.getLabelTraduora("patient.menu.cardiologyAnamnesis"),
      pathEventResource: "/cardioanamnesi",
      keyListaEventi: 0,
      linkEvent: "/paziente/cardiologia/anamnesi",
    };
  },
};
</script>

<style></style>
